module.exports = __webpack_public_path__ + "img/fp.1262ffec.png";